import { EmbeddedCard } from "@/components/molecules/embedded-card";
import { StripesBackground } from "@/components/molecules/stripes";
import { Button } from "@/components/ui/button";
import {
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { useAuth } from "@/features/auth/hooks/use-auth";
import { useUser } from "@/features/auth/hooks/use-user";
import { useTranslation } from "@/features/utils/i18n";
import type { ReactNode } from "react";

interface CompaniesLayoutProps {
  title: string;
  description: string;
  actions?: ReactNode;
  children: ReactNode;
}

export const CompaniesLayout = ({
  title,
  description,
  actions,
  children,
}: CompaniesLayoutProps) => {
  const { t } = useTranslation("start");
  const { logout } = useAuth();
  const { data: user } = useUser();

  return (
    <div className="relative min-h-dvh">
      <div className="absolute w-full h-full top-0 right-0 z-0 overflow-hidden">
        <StripesBackground />
      </div>
      <div className="relative z-10 flex items-center justify-center min-h-dvh p-4">
        <EmbeddedCard logo className="w-full !max-w-6xl">
          <CardHeader>
            <div className="flex items-center justify-between">
              <div className="space-y-1">
                <CardTitle className="text-2xl">{title}</CardTitle>
                <CardDescription>{description}</CardDescription>
              </div>
              {actions && <div>{actions}</div>}
            </div>
          </CardHeader>
          <CardContent className="space-y-6">
            {children}

            {/* Footer */}
            <div className="flex items-center justify-center gap-2 text-sm text-muted-foreground w-full">
              <span>{t("footer.connectedAs", { email: user?.email })}</span>
              <Button
                variant="link"
                onClick={() => logout()}
                className="text-red-500"
              >
                {t("footer.logout")}
              </Button>
            </div>
          </CardContent>
        </EmbeddedCard>
      </div>
    </div>
  );
};
